export default "__VITE_ASSET__B48qHE9l__"